import React from 'react';
import { InputNumber, message } from 'antd';
import { ICartItem, IChangeNumber } from '@/pages/goods/type';
import { DeleteOutlined, CloseOutlined } from '@ant-design/icons';
import { renderIntlLabel } from '@/utils';
import { parseYuan2Currency } from '@/utils/number';

import { calTotalNumAndPrice } from '../help';
import styles from './GoodsCart.module.scss';

interface ICartItemAndHandles extends ICartItem {
  goodsList: any;
  onChangeNumber: (params: IChangeNumber) => void;
  deleteOneCartGoods: any;
}

// 购物车商品项
function CartItem($$: ICartItemAndHandles) {
  const { onChangeNumber, deleteOneCartGoods, index, goodsList, ...rest } = $$;

  const inputNumberConfirm = (e: any) => {
    const val = e.target.value;
    // 正整数校验
    if (!/(^[1-9]\d*$)/.test(val)) {
      message.warn(renderIntlLabel('goods_msg_please_input_again_for_error_value'));
    } else {
      const intialItem = goodsList[index] || {};
      if (Number(val) > intialItem.qty) {
        message.warn(renderIntlLabel('goods_msg_please_input_again_for_error_value'));
        return;
      }
      onChangeNumber({
        type: 'change',
        goodsItem: rest,
        number: Number(val),
        index,
      });
    }
  };

  return (
    <div className={styles.cartItem} key={$$.skuCode}>
      <div className={styles.name}>
        <div className={styles.spu}>{$$.spuName}</div>
        <div className={styles.sku}>{$$.specValues}</div>
      </div>
      <InputNumber
        value={$$.cartNum}
        className={styles.inputNumber}
        onStep={(val, info) => {
          const intialItem = goodsList[index] || {};
          // 前台库存不足
          if (val > intialItem.qty) {
            message.error(renderIntlLabel('goods_msg_add_unsuccessfully_for_understock'));
            return;
          }
          // 减少为0 就是从购物车移除
          if (val === 0 && info.type === 'down') {
            deleteOneCartGoods(rest);
            return;
          }
          onChangeNumber({
            type: 'change',
            goodsItem: rest,
            number: val,
            index,
          });
        }}
        onPressEnter={inputNumberConfirm}
        onBlur={inputNumberConfirm}
      />
      <span>{parseYuan2Currency($$.price || 0)}</span>
      <CloseOutlined
        style={{ fontSize: '9px', cursor: 'pointer', color: '#323233', opacity: 0.45 }}
        onClick={() => {
          deleteOneCartGoods(rest);
        }}
      />
    </div>
  );
}

// 购物车
function GoodsCart($$: any) {
  const {
    list = null,
    goodsList = [],
    onChangeNumber,
    deleteOneCartGoods,
    deleteAllCartGoods,
  } = $$;

  const cartListDom = [];

  if (list) {
    list.forEach((value) => {
      cartListDom.push(
        <CartItem
          {...value}
          goodsList={goodsList}
          key={value.skuCode}
          onChangeNumber={onChangeNumber}
          deleteOneCartGoods={deleteOneCartGoods}
        />,
      );
    });
  }

  // 计算购物车总数与总价
  const { totalNum, totalPrice } = calTotalNumAndPrice(list);

  return (
    <div className={styles.buyCart}>
      <p className={styles.title}>
        {renderIntlLabel('goods_label_shopping_cart')}（{totalNum}）
        <DeleteOutlined
          color="#323233"
          style={{ cursor: 'pointer' }}
          onClick={deleteAllCartGoods}
        />
      </p>
      {(!list || list.size === 0) && (
        <div className={styles.empty}>
          <div>
            <i />
            <p>{renderIntlLabel('goods_label_empty_shopping_cart')}</p>
          </div>
        </div>
      )}
      {list && list.size > 0 && (
        <>
          <div className={styles.cartList}>{cartListDom}</div>
          <div className={styles.cartTotal}>
            <span>
              {renderIntlLabel('goods_label_total_counts_of_goods', { settleTotalCount: totalNum })}
            </span>
            <p>
              <span>{renderIntlLabel('goods_label_total')}</span>
              <b>{parseYuan2Currency(totalPrice)}</b>
            </p>
          </div>
        </>
      )}
    </div>
  );
}

export default GoodsCart;
